import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/momentum-calculator',
  component: () => import('../../routes/MomentumCalculator.svelte'),
  card: {
    id: 'momentum-calculator',
    title: 'Momentum Calculator',
    description: 'Calculate momentum, mass, or velocity using the p = mv formula. Enter any two values to find the third.',
    icon: 'sports_cricket',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/momentum-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Momentum Calculator – Calculate p = mv, Mass & Velocity',
    description:
      'Free momentum calculator to find momentum, mass, or velocity using the p = mv formula. Enter any two values to solve. Includes real-world examples.',
  },
};

export default meta;
